<template>
  <div class="PasswordRecoverCode">
    <TransitionFade>
      <div
        v-if="validCode"
        class="form-panel"
      >
        <TransitionSlide side="right">
          <form
            class="Register"
            @input="validation($event)"
          >
            <div class="form-body">
              <h1 class="title">
                {{ $t('NEW_PASSWORD.TITLE') }}
              </h1>

              <BaseInput
                v-for="(field, i) in fields"
                :key="i"
                v-model="field.value"
                v-bind="field"
              >
                <template #error>
                  <ValidationError
                    :errors="errors"
                    :name="field.name"
                  />
                </template>
              </BaseInput>
            </div>

            <div class="form-footer">
              <BaseButton
                class="register-btn"
                size="l"
                variation="primary"
                @click="submit"
              >
                {{ $t('SEND.BUTTON') }}
              </BaseButton>
            </div>
          </form>
        </TransitionSlide>
      </div>
    </TransitionFade>
  </div>
</template>

<script>
import TransitionFade from '@/transitions/TransitionFade';
import TransitionSlide from '@/transitions/TransitionSlide';
import ValidationError from '@/components/common/ValidationError';
import ValidationMixin from '@/mixins/ValidationMixin';

export default {
  components: {
    TransitionFade,
    TransitionSlide,
    ValidationError,
  },

  mixins: [ValidationMixin],

  data() {
    return {
      validCode: false,
      code: undefined,
      fields: [
        {
          type: 'password',
          name: 'password',
          icon: ['fas', 'key'],
          placeholder: this.$t('PASSWORD.PLACEHOLDER'),
          error: this.$t('FORM.MESSAGE.ERROR.PASSWORD_REGEXP'),
          pattern: '\\S{8,}',
          required: true,
          value: undefined,
          autofocus: true,
          autocomplete: false,
        },
        {
          type: 'password',
          name: 'passwordRepeat',
          icon: ['fas', 'key'],
          placeholder: this.$t('NEW_REPPASSWORD.PLACEHOLDER'),
          error: this.$t('FORM.MESSAGE.ERROR.PASSWORD_REGEXP'),
          pattern: '\\S{8,}',
          required: true,
          value: undefined,
          autocomplete: false,
        },
      ],
    };
  },

  async mounted() {
    this.code = this.$route.params?.code;

    if (!this.code) {
      this.$router.push({ path: '/login' });
    }

    this.validCode = await this.checkCode();
    if (!this.validCode) {
      this.$toast.error(this.$t('RECOVER.ERROR'));
      this.$router.push({ name: 'Login' });
    }

    this.focusFirstInput();
  },

  methods: {
    focusFirstInput() {
      const firstInput = this.$el.querySelector('input#password');
      if (firstInput) firstInput.focus();
    },

    checkCode() {
      return this.$store.dispatch('authModule/passwordRecoverCheckCode', this.code);
    },

    async submit() {
      try {
        const currentForm = document.forms[0];
        this.checkAllFields(currentForm);

        const password = this.getField('password');
        const passwordRepeat = this.getField('passwordRepeat');

        if (this.areErrors()) {
          throw new Error(this.$t('FORM.MESSAGE.ERROR.CHECKFIELDS'));
        }

        if (password !== passwordRepeat) {
          const reppasswordField = currentForm.querySelector('[name=passwordRepeat]');
          this.forceErrorElement(reppasswordField, this.$t('FORM.ERROR.REPEATPASSWORD'));
          throw new Error(this.$t('FORM.MESSAGE.ERROR.PASSWORDSMATCH'));
        }

        const data = { code: this.code, password };
        await this.send(data);
      } catch (error) {
        this.$toast.error(error.message);
      }
    },

    async send(data) {
      await this.$store.dispatch('authModule/updatePassword', data);
    },

    getField(name) {
      return this.fields.find(field => field.name === name)?.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.PasswordRecoverCode{
  background-image: url('~@/assets/images/login.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  display: grid;
  place-items: center;

  .form-panel{
    width: 100%;
    max-width: 550px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    box-shadow: $shadow-elevation-2;
    display: grid;
    overflow: hidden;
    border-radius: $border-radius-m;

    form{
      width: 100%;
      background: #fff;
      padding: $spacing-2xl $spacing-xl;
      display: grid;
      align-items: center;
      gap: $spacing-m;

      .form-body {
        display: grid;
        gap: $spacing-s;

        .title{
          font-size: $font-size-2xl;
          letter-spacing: 1px;
          font-weight: 500;
          text-transform: uppercase;
          color: $color-neutral-darker;
          margin-bottom: $spacing-s;
          text-align: center;
        }

        .description{
          margin-bottom: $spacing-m;
          font-size: $font-size-s;
        }
      }

      .form-footer {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: $spacing-m;
        gap: $spacing-s;

        .login-btn {
          text-transform: uppercase;
          font-weight: 500;
        }

        .recover {
          .BaseButton{
            color: $color-neutral-darker;
            margin-bottom: $spacing-m;
          }
        }
      }
    }
  }
}
</style>
